import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ru'; // Подключаем русскую локализацию

// Активируем плагины
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

// Устанавливаем локаль по умолчанию
dayjs.locale('ru');

export default dayjs;
